var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBannerLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 87,
    height: 52,
    viewBox: "0 0 87 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 52V0C14.1357 13.7043 17.5997 20.8082 38.603 24.0788C68.2132 28.6897 80.9346 43.0345 87 52H0Z",
    fill: "#CCE3F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerLeft);
export default __webpack_public_path__ + "static/media/BannerLeft.1af105fd6f9a643cb95a0dcd2249521b.svg";
export { ForwardRef as ReactComponent };